import { useQuery } from '@tanstack/react-query';

import { PredictedDistanceWithDutiesAndAntiDumping } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useGoodsItemPredictedDistances = (declarationId: string, goodsItemId: string) =>
  useQuery({
    queryKey: ['goodsItemPredictedDistances', goodsItemId],
    queryFn: async (): Promise<PredictedDistanceWithDutiesAndAntiDumping[]> => {
      try {
        const result = await apiClient.declarationsCrud.getPredictedDistances.query({
          params: { declarationId, goodsShipmentItemId: goodsItemId },
        });
        if (result.status !== 200) throw result.body;

        return result.body.data as PredictedDistanceWithDutiesAndAntiDumping[];
      } catch (error) {
        showErrorToast(error, 'Failed to fetch predictions!');
      }
    },
  });
